export default __webpack_public_path__ + "static/media/SWT1360.34I-41619_-24893_0.cd8125f1.jpg";